import React from "react";

import { IconButton } from "@mui/material";
import { CheckBoxRounded, ContentCopyRounded } from "@mui/icons-material";

const CodeCopyBtn = ({ children }: any) => {
  const [copyOk, setCopyOk] = React.useState(false);

  const handleClick = () => {
    navigator.clipboard.writeText(children[0].props.children[0].trim());

    setCopyOk(true);
    setTimeout(() => setCopyOk(false), 1000);
  };

  return (
    <IconButton sx={{ position: "absolute", right: 5, top: 5 }} size="small" onClick={handleClick}>
      {copyOk ? <CheckBoxRounded color="success" /> : <ContentCopyRounded color="action" />}
    </IconButton>
  );
};

export default CodeCopyBtn;
